export function routes($stateProvider) {
    $stateProvider
        .state('app.gas.clientes', {
        url: '/clientes',
        abstract: true
    })
        .state('app.gas.clientes.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Clientes',
        template: '<gas-clientes-list-view></gas-clientes-list-view>',
        role: ['gasOIList'],
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.gas.clientes.details', {
        url: '/{id:int}',
        title: 'Detalhes do Cliente',
        template: '<gas-cliente-details-view></gas-cliente-details-view>',
        role: ['gasOIList'],
    });
}
routes.$inject = ['$stateProvider'];
